import slugify from 'slugify';

/**
 * Charset the dashboard slug editor accepts (validateDashboardPageSlug).
 * DISALLOWED_SLUG_CHARS must stay its exact negation — toSlugInput strips
 * with one what the API validates with the other.
 */
export const SLUG_CHARSET = /^[a-z0-9._-]+$/;

const DISALLOWED_SLUG_CHARS = /[^a-z0-9._-]/g;

/**
 * Normalizes manual slug-field input as the merchant types. Unlike toSlug
 * (used for title→slug generation) it keeps dots and underscores, which
 * SLUG_CHARSET allows.
 */
export function toSlugInput(value: string): string {
  return slugify(value, { lower: true, trim: true }).replace(DISALLOWED_SLUG_CHARS, '');
}
